export enum FileType {
  DIRECTORY = 'directory',
  JAVASCRIPT = 'javascript',
  TYPESCRIPT = 'typescript',
  PYTHON = 'python',
  JSON = 'json',
  OTHER = 'other',
  HTML = 'html'
}

export interface FileData {
  id: string;
  name: string;
  type: FileType;
  content?: string;
  children?: FileData[];
}
